import React, { useState } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { ChevronDown, Weight } from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";

function Whitepapers() {
  const blogs = [
    {
      img: "../images/wh1.png",
      title: "From Signals to Sales: How AI-Powered Intent Data is Redefining B2B Lead Generation in 2025",
      date: "Oct 26, 2025",
      link: "./Whitepapers1",
    },
    {
      img: "../images/wh2.png",
      title: "Amplify. Analyze. Accelerate: How Content Syndication Data Powers High-Impact B2B Leads ",
      date: "Oct 23, 2025",
      link: "./Whitepapers2",
    },
    {
      img: "../images/wh3.png",
      title: "Precision in the Inbox: Turning Email Engagement into Measurable B2B Revenue",
      date: "Oct 20, 2025",
      link: "./Whitepapers3",
    },
    {
      img: "../images/wh4.png",
      title: "Visibility that Converts: How Display Marketing Builds B2B Awareness and Lasting Loyalty",
      date: "Oct 17, 2025",
      link: "./Whitepapers4",
    },
   
  ];

  return (
    <div>
      <Header />
      <main>
      
        {/* 🔹 Hero Section */}
        <section
          className="gj sp1"
          style={{
            marginTop: "70px",
            backgroundImage: "url('images/whitebl.webp')",
            backgroundSize: "cover",
            backgroundRepeat: "no-repeat",
          }}
        ></section>

        {/* 🔹 FAQ Section */}
        <section className="i ji">
          <span className="rc h s r vd fd/5 fh rm"></span>
          <div className="animate_top bb ze rj ki xn vq text-center">
            <motion.section
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.2 }}
              transition={{ duration: 0.8 }}
            >
              <h2 className="fk vj pr kk wm on/5 gq/2 bb _b text-3xl font-bold">
                Whitepaper
              </h2>
            </motion.section>
          </div>
          <div className="wc qf pn xo zf iq ii ji">
        {blogs.map((blog, index) => (
          <div key={index} className="animate_top sg vk rm xm">
            <div className="c rc i z-1 pg">
              <img className="w-full" src={blog.img} alt="Blog" />
              <div className="im h r s df vd yc wg tc wf xf al hh/20 nl il z-10">
                <a
                  href={blog.link}
                  className="vc ek rg lk gh sl ml il gi hi"
                >
                  Read More
                </a>
              </div>
            </div>

            <div className="yh">
              <div className="tc uf wf ag jq">
                <div className="tc wf ag">
                  <img src="images/icon-calender.svg" alt="Calendar" />
                  <p>{blog.date}</p>
                </div>
                <div className="tc wf ag">
                 <p>Published by: Pinakinedge Media</p>
                </div>
              </div>
              <h4 className="blogtitle mk2">
                <a href={blog.link}>{blog.title}</a>
              </h4>
            </div>
          </div>
        ))}
      </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}

export default Whitepapers;
